module.exports = __webpack_public_path__ + "img/secretheart@2x.84e20bd.jpg";